import { track, trackOnExit } from './analytics.js';
import { onAnalyticsReady, mayStartAnalytics } from '../src/posthog.js';
import { onConsentChange } from './consent.js';
import { docsEventProperties } from './developer-docs-events.js';
const pending = [];
onAnalyticsReady(() => { for (const item of pending.splice(0)) track(item.event, item.properties); });
onConsentChange((consent) => { if (!consent.analytics) pending.length = 0; });
export function trackDocs(event, input = {}, exit = false) {
  const properties = docsEventProperties(event, input);
  if (!properties) return false;
  if (exit) return trackOnExit(event, properties);
  if (track(event, properties)) return true;
  if (mayStartAnalytics() && pending.length < 64) pending.push({ event, properties });
  return false;
}
